module.exports = __webpack_public_path__ + "img/blog-main-01.347d6917.jpg";